import { createFileRoute } from '@tanstack/react-router';
import { ReferralsPage } from '@web/modules/referrals/panel/referrals-page';

export const Route = createFileRoute('/_app/capture/referrals/')({
  component: ReferralsPage,
});
